import { render, staticRenderFns } from "./erNoPonds.vue?vue&type=template&id=b2ef9b6c&scoped=true&"
import script from "./erNoPonds.vue?vue&type=script&lang=js&"
export * from "./erNoPonds.vue?vue&type=script&lang=js&"
import style0 from "./erNoPonds.vue?vue&type=style&index=0&id=b2ef9b6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ef9b6c",
  null
  
)

export default component.exports